import { render, staticRenderFns } from "./Newcomer.vue?vue&type=template&id=33ca7f1d&scoped=true&"
import script from "./Newcomer.vue?vue&type=script&lang=js&"
export * from "./Newcomer.vue?vue&type=script&lang=js&"
import style0 from "./Newcomer.vue?vue&type=style&index=0&id=33ca7f1d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33ca7f1d",
  null
  
)

export default component.exports